import { useCallback, useEffect, useMemo, useState } from "react";
import { useRouteHelper } from "../useRouteHelper";
import { useDiagnosticNavigation } from "../useDiagnosticNavigation";
import { UserManagementPopupMode } from "../../../context/diagnosticAgent";
import { AgentRoute } from "../util/agentRoutes";
import { useUserState } from "./useUserState";

export type UseOpenSavedCases = {
  goToMyCases: () => void;
};

//region [[ Text ]]
const LOGIN_TO_SAVED_CASES = "Please sign in to view your saved cases";
//endregion [[ Text ]]

export const useOpenSavedCases: () => UseOpenSavedCases = () => {
  const { isUserLoggedIn } = useUserState();

  const { navigateTo } = useRouteHelper();

  const {
    setLoginPopupState,
    setLoginPopupMessage,
  } = useDiagnosticNavigation();

  const [shouldGoToCasesOnLogin, setShouldGoToCasesOnLogIn] = useState(false);

  useEffect(() => {
    if (isUserLoggedIn && shouldGoToCasesOnLogin) {
      navigateTo({
        route: AgentRoute.Cases,
      });
    }
    setShouldGoToCasesOnLogIn(false);
  }, [isUserLoggedIn, shouldGoToCasesOnLogin, navigateTo]);

  const goToMyCases = useCallback(() => {
    if (!isUserLoggedIn) {
      setLoginPopupState(UserManagementPopupMode.Login);
      setLoginPopupMessage(LOGIN_TO_SAVED_CASES);
      setShouldGoToCasesOnLogIn(true);
    } else {
      navigateTo({ route: AgentRoute.Cases });
    }
  }, [
    isUserLoggedIn,
    setLoginPopupState,
    setLoginPopupMessage,
    setShouldGoToCasesOnLogIn,
    navigateTo,
  ]);

  return useMemo(() => ({ goToMyCases }), [goToMyCases]);
};
